
//alert('pt');

//document.getElementsByTagName('head')[0].appendChild(style);

Uker.busicon = L.icon({
    iconUrl: Uker.URL + '/css/images/bkkS.png',
    //shadowUrl: 'leaf-shadow.png',
    iconSize: [20, 20], // size of the icon
    shadowSize: [0, 0], // size of the shadow
    iconAnchor: [10, 20], // point of the icon which will correspond to marker's location
    shadowAnchor: [0, 0], // the same for the shadow
    popupAnchor: [0, -7] // point from which the popup should open relative to the iconAnchor
});
Uker.busiconOver = L.icon({
    iconUrl: Uker.URL + '/css/images/bkkL.png',
    //shadowUrl: 'leaf-shadow.png',
    iconSize: [32, 32], // size of the icon
    shadowSize: [0, 0], // size of the shadow
    iconAnchor: [16, 32], // point of the icon which will correspond to marker's location
    shadowAnchor: [0, 0], // the same for the shadow
    //popupAnchor: [-20, -5] // point from which the popup should open relative to the iconAnchor
    popupAnchor: [0, -24] // point from which the popup should open relative to the iconAnchor
});
Uker.Pt = {
    Options: {
        pton: true,
    },
    stops: [],
    legend: null,
    routes: [],
    openmarker: [],
    _markers: [],
    preload: function (arrayOfImages) {
        $(arrayOfImages).each(function () {
            $('<img/>')[0].src = this;
            // Alternatively you could use:
            // (new Image()).src = this;
        });
    },
    init: function () {
        Uker.log.log('pt init.v20220712');
        Uker.Pt.preload([
            Uker.URL + '/css/images/bkkL.png',
            Uker.URL + '/css/images/bkkS.png',
        ]);
        //return;
        $(".poi").after(`
                <div id="ptpanel">
                    <div class="ptactive" style="margin-top: 10px;border-radius: 5px;padding: 5px;background-color: #fefefe;font-weight: bold;font-size: 14px;">BKK megállók a közelben<br>
                    <label class="uk-icom-switch">
                    <input type="checkbox" id="pt">
                    <span class="uk-icom-slider uk-icom-round" id="ptslider"></span>
                    </label> <span class="ptactive" style="font-size: 12px">Mutasd a térképen</span>
                    </div>
                </div>
            `);


        //Uker.Pt.setPton();
        $('#pt').prop('checked', Uker.Pt.Options.pton);
        //Uker.Pt.setPton(Uker.Pt.Options.pton);

        $("#pt").change(function () {

            Uker.Pt.setPton($("#pt").prop('checked'));
            if($(this).prop('checked')) {
                Uker.mapInteractionEvent('checked','bkk');
            } else {
                Uker.mapInteractionEvent('unchecked','bkk');

            }
        });


        Uker.log.log('pt init 86');

        if (Uker.Map.mapOptions.zoom < 15) {
            $(".ptactive").css('opacity', '0.5');
        } else {
            $(".ptactive").css('opacity', '1.0');

        }
        Uker.Pt.getStops();

        Uker.mymap.on('moveend', function () {
            if (Uker.Map.mapOptions.zoom < 15) {
                $(".ptactive").css('opacity', '0.5');
                //$(".uk-icom-slider").css('opacity', '0.5');

            } else {
                $(".ptactive").css('opacity', '1');


            }
            Uker.Pt.getStops();
        });
        Uker.mymap.on('moveend', function () {
            //setTimeout()Uker.Pt.openPopup();
            //   setTimeout(() => {Uker.log.log("this is the third message"); Uker.Pt.openPopup();}, 200);

        });
        Uker.mymap.on('popupopen', function (e) {
            var marker = e.popup._source;
            Uker.log.log("popup nyílik");
            Uker.log.log('pt86: ' + marker.options.oid);
            Uker.Map.autoopeopopupid = marker.options.oid;
            Uker.log.log(Uker.Map.autoopeopopupid);

        });
        Uker.mymap.on('popupclose', function (e) {
            var marker = e.popup._source;
            Uker.log.log("popup nyílik");
            Uker.log.log('pt86: ' + marker.options.oid);
            Uker.Map.autoopeopopupid = null;
            Uker.Map.openmarker = [];
            Uker.log.log(Uker.Map.autoopeopopupid);

        });
    },
    deinit: function () {
        Uker.log.log("deinit:pt deinit");
        $("#ptpanel").detach();
        Uker.Pt.Options.pton = false;
        Uker.Pt.getStops();
        //Uker.mymap.removeControl(Uker.Pt.legend);
    },
    setPton: function (tf) {
        //Uker.log.log('setreturn');
        //return;
        //Uker.log.log('setpton:'+ tf);
// checkbox beállítás
        Uker.Pt.Options.pton = tf;
        if (tf) {
            $("#pt").addClass("uk-right-0 ");
            $("#pt_toggle_helper").removeClass("uk-bg-gray-300").addClass("uk-bg-blue-300");
        } else {
            $("#pt").removeClass("uk-right-0");
            $("#pt_toggle_helper").removeClass("uk-bg-blue-300").addClass("uk-bg-gray-300");
        }
// megállók lekérése
        Uker.Pt.getStops();
    },
    removeMarkers: function () {
        Uker.log.log('removeMarkers:remove  popupipd: ' + Uker.Map.autoopeopopupid);
        Uker.log.log(Uker.Pt._markers.length);

        Uker.log.log(Uker.Pt._markers);
        Uker.Pt.openmarker = [];
        Uker.Pt._markers.forEach(function (m) {
            if (m.options.oid != Uker.Map.autoopeopopupid) {
                Uker.mymap.removeLayer(m);
            } else {
                Uker.log.log('nem törlöm: ' + Uker.Map.autoopeopopupid + ' oid:' + m.options.oid);
                Uker.Pt.openmarker = [m];
            }
        });
        Uker.log.log('Uker.Pt.openmarker');
        Uker.log.log(Uker.Pt.openmarker);
        Uker.log.log('Uker.Pt.openmarker vege');

        Uker.Pt._markers = Uker.Pt.openmarker;
        /*Uker.Pt._markers.forEach(function (m) {
         Uker.Pt._markers.pop();
         });
         */
    },
    openPopup: function ( ) {
        Uker.log.log('openPopup ' + Uker.Map.autoopeopopupid);
        Uker.Pt._markers.forEach(layer => {
            Uker.log.log('openPopup: foreach:' + layer.options.oid + ' =? ' + Uker.Map.autoopeopopupid);
            if (layer.options.oid === Uker.Map.autoopeopopupid) {
                Uker.log.log('haho, nyitom');
                layer.openPopup();
                return;
            }
        });
    },
    openPreviuosPopup: function () {
        return;
        if (Uker.Map.autopanprocess == 1) {
            Uker.Pt.openPopup();
            Uker.Map.autopanprocess = 0;
            Uker.log.log('pan 1');


        } else {
            Uker.log.log('pan 0');
        }
        Uker.Map.autopanprocess = 0;
    },
    setStops: function (tmp_stops) {
        Uker.Pt.removeMarkers();
        if (Uker.Pt.Options.pton == false && Uker.mymap.isFullscreen()) {
            return;
        }
        Uker.Pt.stops = tmp_stops;
        Uker.Pt.stops.forEach(function (k) {
            if (Uker.Map.autoopeopopupid != 's' + k.lat + 's' + k.lon + 'n' + k.name) { // ezt a markert nem töröljük le
                //Uker.log.log('bubi stop foreach')
                //Uker.log.log(k);
                var r = k.routes;
                //Uker.log.log(r);
                var m = L.marker([k.lat, k.lon], {
                    icon: Uker.busicon,
                    //title: k.name,
                    oid: 's' + k.lat + 's' + k.lon + 'n' + k.name
                }).bindPopup(
                        L.responsivePopup({autoPanPadding: [20, 45], autoPanSpeed: 45, autoClose: false, minWidth: 180, closeButton: false}).setContent(Uker.Template.routebubi(r, k))

                        ).addTo(Uker.mymap);

                m.on('mouseover', function (alter_style) {
                    var leaflet_obj2 = alter_style.target;
                    leaflet_obj2.setIcon(Uker.busiconOver);
                    leaflet_obj2.setZIndexOffset(3000);
                });
                m.on('click', function (alter_style) {
                    var leaflet_obj2 = alter_style.target;
                    leaflet_obj2.setIcon(Uker.busiconOver);
                });
                m.on('mouseout', function (origin_style) {
                    var leaflet_obj3 = origin_style.target;
                    if (!origin_style.target.isPopupOpen())
                        leaflet_obj3.setIcon(Uker.busicon);
                        leaflet_obj3.setZIndexOffset(0);

                });
                m.on('popupclose', function (origin_style) {
                    var leaflet_obj3 = origin_style.target;
                    leaflet_obj3.setIcon(Uker.busicon);
                    leaflet_obj3.setZIndexOffset(0);

                });

                Uker.Pt._markers.push(m);
            } else {
                Uker.log.log('nem tettük ki: ' + Uker.Map.autoopeopopupid);
            }
        });


        Uker.Pt.computedroutes();
        Uker.Pt.openPreviuosPopup();




    },
    go: function (r) {
        window.open('https://go.bkk.hu/route/BKK_' + r);
        //alert(r);
    },

    getStops: function () {
        //Uker.log.log('pt getStops');
        if ((Uker.Pt.Options.pton == false && ( Uker.mymap.isFullscreen() || Uker.fullscreenstate )) || Uker.Map.mapOptions.zoom < 15) {
// letörüljük, és kész
            Uker.log.log('pton false');

            Uker.Pt.setStops([])
        } else {
            $.getJSON(Uker.PtURL, {
                minLon: Uker.Map.mapOptions.west,
                minLat: Uker.Map.mapOptions.south,
                maxLon: Uker.Map.mapOptions.east,
                maxLat: Uker.Map.mapOptions.north,
                zoom: Uker.Map.mapOptions.zoom,
//p: Uker.Map.checkedPois
            }, function (data) {
                //Uker.log.log('pt move');
                Uker.log.log(data);
                var tmp_stops = [];
                for (stop in data) {
                    //Uker.log.log(stop);
                    //Uker.log.log(data[stop]);
                    var tmp_stop = {};
                    tmp_stop.lon = data[stop].stop_lon;
                    tmp_stop.lat = data[stop].stop_lat;
                    tmp_stop.is_night_service = data[stop].is_night_service;
                    tmp_stop.group_id = data[stop].group_id;
                    tmp_stop.name = data[stop].stop_name;
                    tmp_stop.trip_headsign = data[stop].trip_headsign;
                    tmp_stop.routes = data[stop].routes;
                    tmp_stops.push(tmp_stop);
                }
                Uker.Pt.setStops(tmp_stops);
            })
        }
// checkbox beállítás
// megállók lekérése
    },
    setRoutes: function (routes) {
        return;
        Uker.log.log('setRoutes');
        Uker.log.log(routes);
        Uker.Pt.routes = routes;
        var Item = (r) => `
<span class="">*  ${r}</span>

`;
        r = Uker.Pt.routes;
        let output = r.map((i) => {
            Uker.log.log(i);

            return `
<span class="uk-pt-box  uk-pt-t-${
                    i.type
                    }-${
                    i.is_night_service
                    }
"> ${i.short_name} **</span>
`;


            return `
<span class="uk-leading-loose uk-pt-t-a uk-pt-t-${
                    i.type
                    }-${
                    i.is_night_service
                    }
uk-p-1 uk-m-1 uk-text-xs uk-text uk-font-bold"> ${i.short_name} </span>
`;
        });
//Uker.log.log('temp');
//Uker.log.log(r);
//Uker.log.log(output);
        $('#uk-routes').html(output);
        /*
         $('.list-items').html([
         { url: '/foo', img: 'foo.png', title: 'Foo item' },
         { url: '/bar', img: 'bar.png', title: 'Bar item' },
         ].map(Item).join('
         */
    },
    computedroutes: function () {
        return;
        const routes = [];
//Uker.log.log('computed');
//Uker.log.log(this.stops);
        for (const stop in Uker.Pt.stops) {
//Uker.log.log(`${stop}: ${this.stops[stop]}`);
//Uker.log.log(`${stop}:`);
//Uker.log.log(this.stops[stop].routes);
            for (const route in this.stops[stop].routes) {
                Uker.log.log('RRRRRRRRRRRRRRRRRRRR');
                Uker.log.log(this.stops[stop].routes[route]);
//routes.short_name=
                var index = routes.map(function (o) {
                    return o.short_name;
                }).indexOf(this.stops[stop].routes[route].short_name);
                /*
                 var index = routes.findIndex(function(routes) {
                 return routes.short_name == this.stops[stop].routes[route].short_name;
                 });
                 
                 */
//Uker.log.log('index');
//Uker.log.log(index);
//if (routes.filter(e => e.short_name === this.stops[stop].routes[route].short_name).length == 0 ) {
                if (index == -1) {
                    const t_route = {};
                    t_route.short_name = this.stops[stop].routes[route].short_name;
                    t_route.type = this.stops[stop].routes[route].type;
                    t_route.is_night_service = this.stops[stop].routes[route].is_night_service;
                    t_route.subtype = this.stops[stop].routes[route].subtype;
                    t_route.stops = [stop];
                    routes.push(t_route);
// routes.short_name[]=this.stops[stop].routes[route].short_name
                } else {
                    routes[index].stops.push(stop);
//Uker.log.log('benneje');
// console();
                }
            }
            Uker.log.log('routes');
            Uker.log.log(routes);
        }
        Uker.Pt.setRoutes(routes);
//this.routes = routes;
    },
}

// @lang JavaScript
$(function () {
    Uker.Pt.init();
});

$(function () {
    return;
// Code here
// alert("z");
    var ZoomViewer = L.Control.extend({
        onAdd: function () {
            var gauge = L.DomUtil.create('div');
            gauge.style.width = '30px';
            gauge.style.background = 'rgba(255,255,255,1)';
            gauge.style.textAlign = 'left';
            Uker.mymap.on('zoomstart zoom zoomend', function (ev) {
                gauge.innerHTML = ' ' + Uker.mymap.getZoom();
            });
            return gauge;
        }
    });

    var zoomViewer = (new ZoomViewer()).addTo(Uker.mymap);
});


